<template>
  <v-form ref="formMaterialBlock" class="block-wrapper material-block">
    <header-title :main-title="mainTitle" v-if="mainTitle" />

    <div class="block-container" :inert="scheduleBusy || scheduleLocked ? true : undefined">
      <!-- Заголовок -->
      <title-slot :is-active-big-title="true" :title="inputInfo.title">
        <input-main
          :active-textarea="true"
          :rules="rulesRequired"
          @changeValue="(value) => (form.title = value.value)"
          :value="form.title"
          :info-input="inputInfo"
        />
      </title-slot>

      <title-slot :is-active-big-title="true" :title="inputInfoUrl.title">
        <input-main
          :active-textarea="false"
          @changeValue="(value) => (form.url = value.value)"
          :value="form.url"
          :info-input="inputInfoUrl"
        />
      </title-slot>

      <title-slot :is-active-big-title="true" :title="inputInfoLinkUrl.title">
        <input-main
          :active-textarea="false"
          @changeValue="(value) => (form.linkUrl = value.value)"
          :value="form.linkUrl"
          :info-input="inputInfoLinkUrl"
        />
      </title-slot>

      <!-- Тип материала -->
      <title-slot title="Тип">
        <v-select
          class="custom-select"
          label="Выберите тип материала"
          v-model="form.type"
          :items="selectsType"
          return-object
          item-title="label"
          item-value="label"
        />
      </title-slot>

      <!-- Изображение -->
      <title-slot title="Добавить изображение для превью">
        <file-input
          class="material-file-input"
          :file="defaultFileInput"
          :active-file="form.logo"
          :is-active-img="true"
          @removeFile="form.logo = null"
          @changeFile="
            (value, file, fileSrc) => (form.logo = { file, fileSrc })
          "
        />
      </title-slot>

      <title-slot title="Описание">
        <input-main
          :active-textarea="true"
          :rules="rulesRequired"
          @changeValue="(item) => (form.description = item.value)"
          :value="form.description"
          :info-input="inputInfoDescription"
        />
      </title-slot>

      <!-- Дата публикации -->
      <title-slot title="Дата, указанная в материале">
        <picker-menu-date
          :value="form.date"
          @changeDate="(value) => (form.date = value)"
          placeholder="xx.xx.xxxx"
        />
      </title-slot>

      <!-- Теги -->
      <tags-block
        @changeTags="(tags) => (form.tags = tags)"
        :tags-title="tagsTitle"
        @closeTags="closeTags"
        :tags-out="form.tags"
      />

      <!-- Контент -->
      <title-slot class="editor-wrapper" :title="editorTitle">
        <editor-container
          :active-item="form.text"
          profile="publication"
          @changeEditorContent="(value) => (form.text = value)"
          @contentValidation="(value) => (editorValidation = value)"
        />
      </title-slot>

      <!-- SEO -->
      <title-slot :is-active-big-title="true" title="SEO (необязательно)">
        <input-main
          :active-textarea="true"
          @changeValue="(value) => (form.metaTitle = value.value)"
          :value="form.metaTitle"
          :info-input="inputInfoMetaTitle"
        />
        <input-main
          :active-textarea="true"
          @changeValue="(value) => (form.metaDescription = value.value)"
          :value="form.metaDescription"
          :info-input="inputInfoMetaDescription"
        />
        <input-main
          :active-textarea="true"
          @changeValue="(value) => (form.keywords = value.value)"
          :value="form.keywords"
          :info-input="inputInfoKeywords"
        />
      </title-slot>
    </div>

    <publication-controls :record="scheduleRecord" v-model:schedule="scheduleInput" :busy="scheduleBusy"
      :draft-disabled="!form.title || !form.type || !form.description || !form.text"
      :publish-disabled="idDisabledButton" :notice="scheduleNotice" @action="scheduleAction" />
  </v-form>
</template>

<script>
import HeaderTitle from "@/components/entities/HeaderTitle.vue";
import PickerMenuDate from "@/components/shared/picker/PickerMenuDate.vue";
import BigTitle from "@/components/shared/text/BigTitle.vue";
import ButtonMain from "@/components/shared/buttons/ButtonMain.vue";
import TitleSlot from "@/components/entities/TitleSlot.vue";
import InputMain from "@/components/shared/input/InputMain.vue";
import EditorContainer from "@/components/entities/EditorContainer.vue";
import FileInput from "@/components/shared/input/FileInput.vue";
import TagsBlock from "@/components/entities/CRUDBlock/TagsBlock.vue";
import RulesMixin from "@/mixins/rules.mixin";
import PublicationControls from "@/components/entities/PublicationControls.vue";
import PublicationScheduleMixin from "@/mixins/publication-schedule.mixin";
import { publicationDate } from "@/services/publication-schedule.mjs";
import { api } from "@/middleware/api";

export default {
  name: "MaterialBlock",
  mixins: [RulesMixin, PublicationScheduleMixin],
  components: {
    PublicationControls,
    HeaderTitle,
    PickerMenuDate,
    BigTitle,
    ButtonMain,
    TitleSlot,
    InputMain,
    EditorContainer,
    FileInput,
    TagsBlock,
  },
  data() {
    return {
      mainTitle: "",
      publicationKind: "materials",
      editorTitle: "Текст материала",
      editorValidation: {valid: true, imagesWithoutAlt: 0, message: ""},
      defaultFileInput: {
        placeholder: "Загрузить изображение",
        mimetype: "image/png, image/jpeg, image/jpg",
        mimeTypeString: "PNG, JPEG, JPG",
        size: 0.0035,
        title: "Загрузите файл до 3.5 МБ",
      },
      selectsType: [
        { label: "Кейс", value: "CASE" },
        { label: "СМИ", value: "MEDIA" },
        { label: "Статья", value: "ARTICLE" },
      ],
      form: {
        type: "",
        description: "",
        url: "",
        linkUrl: "",
        date: null,
        logo: null,
        tags: [],
        title: "",
        text: "",
        metaTitle: "",
        metaDescription: "",
        keywords: "",
      },
    };
  },
  computed: {
    idDisabledButton() {
      return (
        !this.form.title?.trim() ||
        !this.form.description?.trim() ||
        !this.form.type ||
        (!this.form.logo?.file && !this.form.logo?.logoKey) ||
        !this.form.text ||
        !this.editorValidation.valid
      );
    },
    tagsTitle() {
      return "Добавить теги";
    },
    inputInfoDescription() {
      return {
        maxLength: 200,
        placeholder: "Введите текст",
      };
    },
    inputInfo() {
      return {
        type: "big",
        title: "Заголовок",
        maxLength: 80,
        placeholder: "Введите текст",
        key: "title",
      };
    },
    inputInfoUrl() {
      return {
        placeholder: "Введите URL страницы",
        type: "big",
        title: "URL страницы",
      };
    },
    inputInfoLinkUrl() {
      return {
        placeholder: "Введите ссылку на материал",
        type: "big",
        title: "Ссылка на материал",
      };
    },
    inputInfoMetaTitle() {
      return { maxLength: 70, placeholder: "Meta Title" };
    },
    inputInfoMetaDescription() {
      return { maxLength: 170, placeholder: "Meta Description" };
    },
    inputInfoKeywords() {
      return { maxLength: 255, placeholder: "Keywords" };
    },
  },
  async mounted() {
    const id = this.$route.params.id;
    if (id) {
      this.mainTitle = "Редактировать материал";
      const { data } = await api.dashboard.adminMaterialsControllerFindOne(id);
      this.form = {
        ...data,
        tags: data.tags.map((e) => e.id),
        logo: {
          logoKey:
            data.translations[0]?.preview?.s3Key ||
            data.translations[0]?.file?.s3Key,
        },
        title: data.translations[0].title,
        description: data.translations[0].description,
        text: data.translations[0].text,
        metaTitle: data.seoTitle,
        metaDescription: data.seoDescriptions,
        keywords: data.keyWords,
        date: data.publication?.displayDate || data.publishedAt,
        type: this.selectsType.find((e) => e.value === data.type),
      };
    } else {
      this.mainTitle = "Создать новый материал";
    }
    await this.initSchedule(id);
  },
  methods: {
    publicationDisplayDate() { return this.form.date; },
    setPublicationDisplayDate(value) { this.form.date = value; },
    async savePublicationDraft() {
      return this.scheduleEntityId ? this.updateMaterial(this.scheduleEntityId) : this.createMaterial();
    },
    async updateMaterial(id) {
      if (this.form.logo?.file) {
        try {
          await this.uploadPreview(id);
        } catch (error) {
          throw this.withPublicationStage(error, "preview", id);
        }
      }
      const { data } = await api.dashboard.adminMaterialsControllerUpdate(
        id,
        this.materialPayload(this.scheduleRecord.state === "PUBLISHED" ? "PUBLISHED" : "DRAFT")
      );
      return data;
    },
    async createMaterial() {
      const { data: draft } = await api.dashboard.adminMaterialsControllerCreate(
        this.materialPayload("DRAFT")
      );
      this.scheduleEntityId = draft.id;
      try {
        if (this.form.logo?.file) await this.uploadPreview(draft.id);
      } catch (error) {
        throw this.withPublicationStage(error, "preview", draft.id);
      }
      return draft;
    },
    materialPayload(status) {
      return {
          url: this.form.url,
          linkUrl: this.form.linkUrl,
          seoTitle: this.form.metaTitle,
          seoDescriptions: this.form.metaDescription,
          keyWords: this.form.keywords,
          status,
          type: this.form.type.value,
          tagIds: this.form.tags,
          translations: [
            {
              title: this.form.title,
              description: this.form.description,
              text: this.form.text,
              langCode: "RU",
            },
          ],
          ...(this.form.date ? { publishedAt: publicationDate(this.form.date) } : {}),
      };
    },
    async uploadPreview(id) {
      const { data } = await api.dashboard.adminMaterialsControllerUploadFile(id, {
        file: this.form.logo.file,
        langCode: "RU",
        type: "PREVIEW",
        deferRebuild: "true",
      });
      const logoKey = data?.preview?.s3Key || data?.file?.s3Key;
      if (logoKey) this.form.logo = { logoKey };
      return data;
    },
    withPublicationStage(error, publicationStage, materialId) {
      const wrapped = new Error(error?.message || publicationStage);
      wrapped.response = error?.response;
      wrapped.cause = error;
      wrapped.publicationStage = publicationStage;
      wrapped.materialId = materialId;
      return wrapped;
    },
    closeTags(item) {
      const idx = this.form.tags.findIndex((t) => t.id === item.id);
      if (idx !== -1) this.form.tags.splice(idx, 1);
    },
  },
};
</script>

<style scoped lang="scss">
.header-title-container {
  margin-bottom: -40px;
}
.material-block {
  max-width: 1000px;
  .material-file-input {
    min-height: 180px;
  }
}

</style>
